var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1070_3874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7999 0H10.9279C11.0308 1.26945 10.5461 2.21783 9.95729 2.90475C9.37949 3.58695 8.58839 4.24845 7.30859 4.1481C7.22332 2.89688 7.70864 2.0187 8.29657 1.33335C8.84219 0.6948 9.84209 0.12645 10.7999 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6747 13.2124V13.2479C14.3152 14.3372 13.8022 15.2707 13.176 16.1369C12.6045 16.9233 11.9043 17.9817 10.6538 17.9817C9.5733 17.9817 8.85555 17.2869 7.7481 17.268C6.57675 17.2491 5.93258 17.849 4.86158 17.9999H4.4964C3.71003 17.8861 3.0753 17.2633 2.61293 16.7021C1.24965 15.0439 0.195975 12.9019 0 10.1607V9.35521C0.083025 7.39344 1.03613 5.79841 2.30333 5.02531C2.97203 4.61424 3.89115 4.26414 4.9149 4.42074C5.35365 4.48869 5.80185 4.63899 6.19448 4.78749C6.56685 4.93059 7.03238 5.18416 7.47338 5.17089C7.77218 5.16211 8.0694 5.00641 8.37045 4.89661C9.25245 4.57801 10.1174 4.21284 11.257 4.38451C12.6268 4.59151 13.599 5.20014 14.1997 6.13929C13.041 6.87684 12.125 7.98811 12.2814 9.88576C12.4205 11.6097 13.4228 12.6182 14.6747 13.2126V13.2124Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1070_3874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6747,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIconBlack);
export default __webpack_public_path__ + "static/media/apple-icon-black.c6d382a0c9950fbbc8eed02a36421dee.svg";
export { ForwardRef as ReactComponent };